import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useApiClient } from '../../context/ApiClientContext';
import Dropdown from '../../components/controls/Dropdown';

export default function MedicationDropdown(props) {
  const {
    name, value, onChange, label, error,
  } = props;
  const [medications, setMedications] = useState([]);

  const apiClient = useApiClient();

  useEffect(() => {
    async function getMedications() {
      const result = await apiClient.getAllMedications();
      const medsData = result.data.map((medication) => ({
        id: medication.id,
        name: medication.genericName,
      }));
      setMedications(medsData);
    }
    getMedications();
  }, []);

  return (
    <Dropdown
      name={name}
      value={value}
      onChange={onChange}
      label={label}
      error={error}
      options={medications}
    />
  );
}

MedicationDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
};

MedicationDropdown.defaultProps = {
  error: null,
};
